// Return-URL persistence for the OIDC login round-trip.
// Single owner: guards, callback pages and AuthContext all go through here.

export const RETURN_URL_KEY = 'auth_return_url';

// Same-origin path only: one leading slash, not "//host", scheme, or backslash.
export const isInternalReturnPath = (url) =>
  typeof url === 'string' && /^\/(?![/\\])/.test(url);

// Never bounce back into the auth flow itself. Exported so handleSessionExpired can use the
// same test before a hard navigation to /auth, which would reload the page if already there.
export const isAuthPath = (url) => {
  const path = url.split(/[?#]/)[0];
  return path === '/auth' || path === '/auth/callback';
};

export const pathFromLocation = (location) =>
  `${location.pathname}${location.search || ''}${location.hash || ''}`;

export const saveReturnUrl = (url) => {
  if (isInternalReturnPath(url) && !isAuthPath(url)) {
    sessionStorage.setItem(RETURN_URL_KEY, url);
  }
};

// Read + remove atomically; validate before trusting the stored value.
export const consumeReturnUrl = (defaultUrl) => {
  const saved = sessionStorage.getItem(RETURN_URL_KEY);
  sessionStorage.removeItem(RETURN_URL_KEY);
  return saved && isInternalReturnPath(saved) && !isAuthPath(saved) ? saved : defaultUrl;
};
